export enum FilterFields {
  ClientAmountFrom = 'ca_search_AmountFrom',
  ClientAmountTo = 'ca_search_AmountTo',
  ClientClientAmountFrom = 'ca_search_ClientAmountFrom',
  ClientClientAmountTo = 'ca_search_ClientAmountTo',
  QueryAmountFrom = 'query_search_AmountFrom',
  QueryAmountTo = 'query_search_AmountTo',
  QueryVolumeFrom = 'query_search_VolumeFrom',
  QueryVolumeTo = 'query_search_VolumeTo',
  ClientVolumeFrom = 'ca_search_VolumeFrom',
  ClientVolumeTo = 'ca_search_VolumeTo',
  ClientPriceFrom = 'ca_search_PriceFrom',
  ClientPriceTo = 'ca_search_PriceTo',
  ClientDateFrom = 'ca_search_DateFrom',
  ClientDateTo = 'ca_search_DateTo',
  ClientName = 'ca_search_ClientName',
  ClientRegistrationDateFrom = 'ca_search_RegistrationDateFrom',
  ClientRegistrationDateTo = 'ca_search_RegistrationDateTo',
  DateFrom = 'DateFrom',
  DateTo = 'DateTo',
  AmountFrom = 'ca_search_AmountFrom',
  AmountTo = 'ca_search_AmountTo',
  TradingAccountsCountFrom = 'ca_search_TradingAccountsCountFrom',
  TradingAccountsCountTo = 'ca_search_TradingAccountsCountTo',
  TradingAccountName = 'ca_search_TradingAccountName',
  Name = 'ca_search_Name',
  SignedUpDateFrom = 'ca_search_SignedUpDateFrom',
  SignedUpDateTo = 'ca_search_SignedUpDateTo',
  VolumeFxmFrom = 'ca_search_VolumeFxmFrom',
  VolumeFxmTo = 'ca_search_VolumeFxmTo',
  VolumeOtherFrom = 'ca_search_VolumeOtherFrom',
  VolumeOtherTo = 'ca_search_VolumeOtherTo',
  TotalCommissionFrom = 'ca_search_TotalCommissionFrom',
  TotalCommissionTo = 'ca_search_TotalCommissionTo',
  RebateAmountFrom = 'ca_search_RebateAmountFrom',
  RebateAmountTo = 'ca_search_RebateAmountTo',
  HasRebate = 'ca_search_HasRebate',
  AccumulatedVolumeOtherFrom = 'ca_search_AccumulatedVolumeOtherFrom',
  AccumulatedVolumeOtherTo = 'ca_search_AccumulatedVolumeOtherTo',
  AccumulatedVolumeFxmFrom = 'ca_search_AccumulatedVolumeFxmFrom',
  AccumulatedVolumeFxmTo = 'ca_search_AccumulatedVolumeFxmTo',
  AccumulatedCommissionFrom = 'ca_search_AccumulatedCommissionFrom',
  AccumulatedCommissionTo = 'ca_search_AccumulatedCommissionTo',
  RebateApprovalType = 'ca_search_RebateApprovalType',
  RebatePeriod = 'ca_search_RebatePeriod',
  Country = 'ca_search_Country',
  TradingAccountId = 'ca_search_TradingAccountId',
  ClientId = 'ca_search_ClientId',
  IntroducingBrokerGroupId = 'ca_search_IntroducingBrokerGroupId',
  HasTradingAccounts = 'ca_search_HasTradingAccounts',
  TradingAccountType = 'ca_search_TradingAccountType',
  RebateGroupId = 'ca_search_RebateGroupId',
  TransactionDateFrom = 'ca_search_TransactionDateFrom',
  TransactionDateTo = 'ca_search_TransactionDateTo',
  TransactionDateTimeFrom = 'ca_search_TransactionDateTimeFrom',
  TransactionDateTimeTo = 'ca_search_TransactionDateTimeTo',
  ShowNotification = 'ca_search_ShowNotification',
}
